import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';
import { getQueryVariable, handleUserInfo } from '@/utils/util';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      redirect: '/chat'
    },
    {
      path: '/chat',
      name: 'ChatDemo',
      component: r =>
        require.ensure(
          [],
          () => r(require('@/pages/chat-demo/main.vue')),
          'ChatDemo'
        ),
      meta: {
        title: '誉鉴AI智能问答助手'
      }
    },
    {
      path: '/error',
      name: 'Error',
      component: r =>
        require.ensure(
          [],
          () => r(require('@/pages/error/index.vue')),
          'Error'
        ),
      meta: {
        title: '出错了'
      }
    }
    // {
    //   path: '/error/:message',
    //   name: 'ErrorWithMessage',
    //   component: r =>
    //     require.ensure([], () => r(require('@/pages/error/index.vue')), 'Error')
    // }
  ]
});

// 添加导航守卫
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title;
  // if (to.name && window.$initType !== to.name) {
  //   window.location.reload();
  // }
  // 如果是跳转到error页面，则直接跳转，避免死循环
  if (to.path === '/error') {
    next();
    return;
  }

  // 获取URL中的token参数
  const token = getQueryVariable('token');
  // console.error('token:', token);

  if (token) {
    // 如果URL中有token参数，则调用接口获取用户信息
    try {
      // 假设用户信息接口为 /api/user/info，实际项目中可能需要根据实际情况调整
      const response = await axios.get(
        '/home-api/learn/user/getOaUserInfo',
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      if (response.data.code === 200) {
        // // 将用户信息保存到sessionStorage
        // sessionStorage.setItem('userInfo', JSON.stringify(response.data.data.user));
        handleUserInfo(response.data.data);
        next();
      } else {
        // 开发模式下不跳转到错误页面，方便调试
        if (process.env.NODE_ENV === 'development') {
          console.warn('用户信息获取失败，但在开发模式下不跳转到错误页面');
          next();
        } else {
          next('/error');
        }
      }
    } catch (error) {
      // 如果获取用户信息失败，则报错
      console.error('获取用户信息失败:', error);
      // 开发模式下不跳转到错误页面，方便调试
      if (process.env.NODE_ENV === 'development') {
        console.warn('获取用户信息失败，但在开发模式下不跳转到错误页面');
        next();
      } else {
        // 跳转到异常页面
        next('/error');
      }
    }
  } else {
    // 如果URL中没有token参数，则检查sessionStorage中是否有用户信息
    const userInfo = sessionStorage.getItem('userInfo');

    if (userInfo) {
      // 如果sessionStorage中有用户信息，则继续跳转
      next();
    } else {
      // 如果sessionStorage中也没有用户信息，则报错
      console.error('没有用户信息，请提供token参数');
      // 开发模式下不跳转到错误页面，方便调试
      if (process.env.NODE_ENV === 'development') {
        console.warn('没有用户信息，但在开发模式下不跳转到错误页面');
        next();
      } else {
        // 跳转到异常页面
        next('/error');
      }
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js